module.exports = __webpack_public_path__ + "static/media/fpm2.912e781b.png";